import { render, staticRenderFns } from "./CardTitleAndIcon.vue?vue&type=template&id=20be8c52&scoped=true&"
import script from "./CardTitleAndIcon.vue?vue&type=script&lang=ts&"
export * from "./CardTitleAndIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CardTitleAndIcon.vue?vue&type=style&index=0&id=20be8c52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20be8c52",
  null
  
)

export default component.exports